/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetWorkflowStepsResponse = {
  type: 'all-of',
  contains: [{
    type: 'ListResponse',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'WorkflowStep',
        },
        isRequired: true,
      },
    },
  }],
} as const;
